import { IComputedWidget } from '../../../widgets/repository/computed/IComputedWidget';
import { Datatype } from '../../datatype/Datatype';
import { IReference, ReferenceType } from '../IReference';
import { IReferencePath } from '../IReferencePath';

/**
 * Diversifichiamo dalla funzione getSimpleWidgetReference per ottenere le
 * reference dinamiche
 */
export function getDynamicWidgetReference(
  type: Datatype.Boolean | Datatype.Number | Datatype.Date | Datatype.String,
) {
  return (path: IReferencePath, widget: IComputedWidget): IReference => {
    return {
      type: ReferenceType.Widget,
      widgetType: widget.type,
      path,
      id: widget.id,
      code: widget.code,
      label: widget.code,
      field: {
        type,
      },
    };
  };
}
